import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import Card from "./ProjectCard";
import { useTranslation } from "react-i18next";
import KashimaDogClubImg from "../../images/project-showcase/kashima.png";
import chatbotImg from "../../images/project-showcase/chatbot.png";
import nextcloudImg from "../../images/project-showcase/next-cloud.png";
import marketImg from "../../images/project-showcase/market-bridge-japan.png";
import talkImg from "../../images/project-showcase/talk.png";
import taskImg from "../../images/project-showcase/Task.png";
const images = [
  chatbotImg,
  nextcloudImg,
  marketImg,
  KashimaDogClubImg,
  taskImg,
  talkImg,
];

export default () => {
  const { t } = useTranslation();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const cardsData = t("project_showcase_items", { returnObjects: true });

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 768);
    handleResize(); // Check on component mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ margin: "40px 0px" }}>
      <Marquee
        gradientColor="#fafafa"
        direction="left"
        gradient={!isSmallScreen}
      >
        {[...cardsData, ...cardsData].map((card, index) => (
          <Card
            key={index}
            imageSrc={images[index % images.length]} // Modulo ensures no undefined index
            title={card.title}
          />
        ))}
      </Marquee>
    </div>
  );
};
